// src/i18n.js
// i18n centralisé (modèle site-next) : fichiers de traduction uniques
// src/i18n/locales/fr.json + en.json, namespace `translation`, clés imbriquées.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './i18n/locales/fr.json';
import en from './i18n/locales/en.json';

// Clé standard i18next. On écrit AUSSI l'ancienne clé pour rester compatible
// avec les lectures existantes (navConfig.pickLang lit i18nextLng ;
// Settings/Account lisent user-language-preference) → plus de divergence.
const LANG_KEY = 'i18nextLng';
const LEGACY_KEY = 'user-language-preference';

function getInitialLang() {
  try {
    const saved =
      localStorage.getItem(LANG_KEY) || localStorage.getItem(LEGACY_KEY);
    if (saved) return saved.slice(0, 2);
  } catch {}
  return navigator?.language?.slice(0, 2) || 'fr';
}

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  lng: getInitialLang(),
  fallbackLng: 'fr',
  supportedLngs: ['fr', 'en'],
  interpolation: { escapeValue: false },
});

// Source unique pour changer la langue : garde les deux clés localStorage
// synchronisées et met à jour <html lang>.
export function setAppLanguage(lng) {
  const code = (lng || 'fr').slice(0, 2);
  try {
    localStorage.setItem(LANG_KEY, code);
    localStorage.setItem(LEGACY_KEY, code);
  } catch {}
  i18n.changeLanguage(code);
  try {
    document.documentElement.lang = code;
  } catch {}
}

export default i18n;
